import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useId } from "react";
import { TypoHeader } from "ui/Typo";
import { cn } from "utils/helpers/cn";
interface FieldsetProps {
  children?: ReactNode;
  title?: string;
  className?: string;
  variant?: "grey" | "light";
}
function Fieldset(t0) {
  const $ = _c(14);
  const {
    children,
    title,
    className,
    variant: t1
  } = t0;
  const variant = t1 === undefined ? "light" : t1;
  const id = useId();
  let t2;
  if ($[0] !== title) {
    t2 = title?.replace(/\s+/g, "");
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const titleWithoutSpaces = t2;
  const titleId = title && `${titleWithoutSpaces}-${id}`;
  const t3 = variant === "grey";
  let t4;
  if ($[2] !== className || $[3] !== t3) {
    t4 = cn("flex w-full flex-col gap-n4", {
      "rounded-sm bg-gray3 p-n4 dark:bg-transparent": t3
    }, className);
    $[2] = className;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== title || $[6] !== titleId || $[7] !== variant) {
    t5 = title && <TypoHeader id={titleId} className={cn({
      "border-neutral-200 border-b pb-n1 dark:border-primary-foreground": variant === "light"
    })}>{title}</TypoHeader>;
    $[5] = title;
    $[6] = titleId;
    $[7] = variant;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== children || $[10] !== t4 || $[11] !== t5 || $[12] !== titleId) {
    t6 = <div role="group" aria-labelledby={titleId} className={t4}>{t5}{children}</div>;
    $[9] = children;
    $[10] = t4;
    $[11] = t5;
    $[12] = titleId;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
export default Fieldset;